import React from "react";
import { PenNib, Sun, Moon } from "@phosphor-icons/react";
import { useTheme } from "@/context/ThemeContext";

export function ThemeToggle() {
  const { theme, toggle } = useTheme();
  return (
    <button
      data-testid="theme-toggle"
      onClick={toggle}
      className="h-9 w-9 grid place-items-center rounded-sm border border-border bg-surface hover:bg-surface-hover text-foreground transition-colors"
      title="Changer de thème"
    >
      {theme === "dark" ? <Sun size={18} weight="duotone" /> : <Moon size={18} weight="duotone" />}
    </button>
  );
}

export function Brand({ onClick, size = 24 }) {
  return (
    <button onClick={onClick} className="flex items-center gap-2 group" data-testid="brand-logo">
      <PenNib size={size} weight="duotone" className="text-primary" />
      <span className="font-serif tracking-tight" style={{ fontSize: size * 0.9 }}>EDITORIX</span>
    </button>
  );
}
